import { createElement, forwardRef } from 'react';
import { TokenDragType } from '../../TokenInput';
import { setRef } from '../../../util/ref-util';
import { Flow } from '../../Layouts/Flow';
import { DraggableTokenContainerProps, TokenDesignContainerProps, useDraggableToken } from '.';
import cx from 'classnames';

export const TokenDesignContainer = forwardRef<HTMLDivElement, TokenDesignContainerProps>(
  function TokenDesignContainer({ dndProps, ...props }, ref) {
    return dndProps ? (
      <DraggableTokenContainer {...props} dndProps={dndProps} ref={ref} />
    ) : (
      <Flow {...props} ref={ref} />
    );
  }
);

const DraggableTokenContainer = forwardRef<HTMLDivElement, DraggableTokenContainerProps>(
  function TokenDesignContainer({ dndProps, ...props }, ref) {
    const {
      ref: draggableRef,
      style: draggableStyle,
      className: draggableClassName,
    } = useDraggableToken({
      ...dndProps,
      allowDrag: true,
      type: TokenDragType,
    });

    return (
      <Flow
        {...props}
        ref={(e) => {
          setRef(ref, e);
          setRef(draggableRef, e);
        }}
        style={{ ...props.style, ...draggableStyle }}
        className={cx(props.className, draggableClassName)}
      />
    );
  }
);
